import React from "react";
import {
  UserGroupIcon,
  BriefcaseIcon,
  XMarkIcon,
  SparklesIcon, // 🔹 new icon for Create Project
} from "@heroicons/react/24/outline";

const CODI_AVATAR_SRC = `${process.env.PUBLIC_URL || ""}/CodiCharacter.png`;

const CodiBadge = () => (
  <div className="flex items-center gap-2">
    <span className="relative h-6 w-6">
      <span
        className="pointer-events-none absolute -inset-1 rounded-full
                   bg-gradient-to-tr from-fuchsia-400/35 via-sky-400/30 to-emerald-400/35"
        aria-hidden
      />
      <img
        src={CODI_AVATAR_SRC}
        alt="Codi"
        className="relative h-6 w-6 object-contain drop-shadow-sm"
      />
    </span>
    <span className="text-xs font-semibold text-gray-700">Codi</span>
  </div>
);

const hoverStyles = {
  people:
    "hover:-translate-y-1 hover:shadow-lg hover:border-fuchsia-300 hover:bg-gradient-to-r hover:from-pink-50 hover:to-fuchsia-50",
  projects:
    "hover:-translate-y-1 hover:shadow-lg hover:border-sky-300 hover:bg-gradient-to-r hover:from-sky-50 hover:to-blue-50",
  create:
    "hover:-translate-y-1 hover:shadow-lg hover:border-emerald-300 hover:bg-gradient-to-r hover:from-emerald-50 hover:to-green-50",
};

const ActionCard = ({ icon: Icon, title, desc, onClick, variant }) => (
  <button
    onClick={onClick}
    className={`group w-full md:w-[260px] text-left rounded-2xl border border-gray-200 bg-white transition p-4 shadow-sm ${hoverStyles[variant]}`}
  >
    <div className="flex items-center gap-3">
      <div className="h-10 w-10 rounded-xl bg-neutral-100 grid place-items-center group-hover:scale-110 transition-transform">
        <Icon className="h-6 w-6 text-gray-700 group-hover:text-black transition-colors" />
      </div>
    </div>
    <div className="mt-3 font-semibold">{title}</div>
    <div className="text-sm text-gray-600">{desc}</div>
  </button>
);

const OSHome = ({ builder, onPeople, onProjects, onCreateProject, onDismiss }) => {
  const first = builder?.name?.split(" ")[0] || "builder";
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 md:p-5 shadow-sm mb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <CodiBadge />
          <div>
            <div className="text-sm text-gray-600">Welcome back,</div>
            <div className="text-lg font-semibold">{first} — what do you want to do?</div>
          </div>
        </div>
        <button
          aria-label="Hide launcher"
          onClick={onDismiss}
          className="h-8 w-8 grid place-items-center rounded-md hover:bg-gray-100"
        >
          <XMarkIcon className="h-5 w-5 text-gray-600" />
        </button>
      </div>

      <div className="mt-4 flex flex-col md:flex-row gap-3">
        <ActionCard
          icon={UserGroupIcon}
          title="Find People"
          desc="Match builders by role, skills, location, availability."
          onClick={onPeople}
          variant="people"
        />
        <ActionCard
          icon={BriefcaseIcon}
          title="Find Projects"
          desc="Discover projects that need your skills."
          onClick={onProjects}
          variant="projects"
        />
        <ActionCard
          icon={SparklesIcon}
          title="Create Project"
          desc="Start a new project and share it with the community."
          onClick={onCreateProject}
          variant="create"
        />
      </div>
    </div>
  );
};

export default OSHome;
